import { useState } from "react"
import * as React from "react"
import "./style.css"
import { useTranslation } from "react-i18next"
import { accountApi } from "../../api/account"
import AppProps from "../../util/AppProps"
import { Button, Checkbox, Form, Input } from "antd"
import { FormComponentProps } from "antd/lib/form"
import { StorageKey } from "../../util/Storage"
import { Link } from "react-router-dom"
import { Shape } from "../../animation/LoginAnimation"
import UserProps from "../../util/UserProps"

const FormItem = Form.Item

const NormalLoginForm = (props: FormComponentProps & AppProps & UserProps) => {
    const { t } = useTranslation("global")

    const [state, setState] = useState({
        shapes: Shape.defaultArray,
        unauthorized: false,
    })

    const login = (e) => {
        e.preventDefault()
        props.form.validateFields((err, values) => {
            if (err) {
                return
            }
            accountApi.login(values.username, values.password, values.remember).then((success) => {
                if (success) {
                    localStorage.removeItem(StorageKey.AdvertiserId)
                    props.history.push("/")
                } else {
                    setState({
                        ...state,
                        unauthorized: true,
                    })
                }
            })
        })
    }

    const { getFieldDecorator } = props.form

    return (
        <Form key={3} onSubmit={login} className="login-form">
            <FormItem>
                {getFieldDecorator("username", {
                    rules: [{ required: true, message: t("Please input your email address") }],
                })(
                    <div className="form-group-input">
                        <Input
                            id="usernameInput"
                            className="form-control-input"
                            size="large"
                            type="text"
                            placeholder=" "
                        />
                        <label htmlFor="usernameInput" className="form-control-placeholder">
                            {t("Email address")}
                        </label>
                    </div>
                )}
            </FormItem>
            <FormItem>
                {getFieldDecorator("password", {
                    rules: [{ required: true, message: t("Please input your password") }],
                })(
                    <div className="form-group-input">
                        <Input
                            id="passwordInput"
                            className="form-control-input"
                            size="large"
                            type="password"
                            placeholder=" "
                        />
                        <label htmlFor="passwordInput" className="form-control-placeholder">
                            {t("Password")}
                        </label>
                    </div>
                )}
            </FormItem>
            <div className="remember-me-container">
                {getFieldDecorator("remember", {
                    valuePropName: "checked",
                    initialValue: false,
                })(<Checkbox className="remember-me">{t("Remember me")}</Checkbox>)}
                <Button type="primary" htmlType="submit" className="login-form-button login-form-button__mobile">
                    LOG IN
                </Button>
                <Link className="forgot-pass" to={`/forgotpassword`}>
                    {t("Forgot password?")}
                </Link>
            </div>
            <Button type="primary" htmlType="submit" className="login-form-button login-form-button__desktop">
                LOG IN
            </Button>
            {state.unauthorized && (
                <div className="login-form-alert">
                    <img src={"/images/error_alert.png"} alt="" />
                    {localStorage.getItem(StorageKey.ApiError)}
                </div>
            )}
        </Form>
    )
}

const LoginForm = Form.create()(NormalLoginForm)

export default LoginForm



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/auth/Login.tsx